import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcCartH72(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "72",
    height: "72",
    fill: "none",
    viewBox: "0 0 72 72",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M26.293 51.77a6.752 6.752 0 1 1 0 13.505 6.752 6.752 0 0 1 0-13.504m0 4.5a2.252 2.252 0 1 0 0 4.505 2.252 2.252 0 0 0 0-4.504M50.305 51.77a6.752 6.752 0 1 1 0 13.505 6.752 6.752 0 0 1 0-13.504m0 4.5a2.252 2.252 0 1 0 0 4.505 2.252 2.252 0 0 0 0-4.504",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.372 6.788a5.25 5.25 0 0 1 5.142 4.056l1.16 4.97h41.278c3.359 0 5.854 3.11 5.125 6.39L58.414 43.18a5.25 5.25 0 0 1-5.125 4.111H23.582a5.25 5.25 0 0 1-5.111-4.054L15.875 32.15q-.014-.043-.024-.086l-3.153-13.488-.004-.02-1.562-6.689a.75.75 0 0 0-.734-.579l-5.68.032a2.25 2.25 0 0 1-.026-4.5z"
  }));
}
var IcCartH72 = createNolIcon(/*#__PURE__*/forwardRef(SvgIcCartH72));

export { IcCartH72 as I };
